import { ComponentsOverrides, Theme } from "@mui/material";
import { InternalThemeConfig } from "../../config";

const mobileStepper = ({ spacing, palette }: InternalThemeConfig): ComponentsOverrides<Theme>["MuiMobileStepper"] => {
	const rem08 = spacing(1);

	return {
		root: {
			color: palette.coolGrey,
			marginBottom: 0,
			background: palette.transparent,
		},
		dot: {
			width: rem08,
			height: rem08,
			border: `0.1rem solid ${palette.grey40}`,
			backgroundColor: undefined,
			margin: `0 ${rem08}`,
		},
		dotActive: {
			backgroundColor: palette.primary,
			borderColor: palette.primary,
		},
	};
};

export default mobileStepper;
